import { createBrowserRouter, Navigate } from 'react-router-dom'
import { LoginPageSaas } from '@/pages/auth/LoginPageSaas'
import { InvitePage } from '@/pages/auth/InvitePage'
import { PlatformLayout } from '@/components/layout/PlatformLayout'
import { PlatformLoginPage } from '@/pages/platform/PlatformLoginPage'
import { PlatformTenantsPage } from '@/pages/platform/PlatformTenantsPage'
import { sharedAppRoutes } from '@/app/router.shared'

export const saasRouter = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPageSaas />,
  },
  {
    path: '/platform/login',
    element: <PlatformLoginPage />,
  },
  {
    path: '/platform',
    element: <PlatformLayout />,
    children: [
      { index: true, element: <PlatformTenantsPage /> },
    ],
  },
  {
    path: '/invite/:token',
    element: <InvitePage />,
  },
  ...sharedAppRoutes,
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
])
